import { useEffect, useState } from "react";
import Lenis from "lenis";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Collection } from "@/components/Collection";
import { Lookbook } from "@/components/Lookbook";
import { Drop } from "@/components/Drop";
import { Footer } from "@/components/Footer";
import Admin from "@/pages/Admin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Site = () => {
    const [site, setSite] = useState(null);
    useEffect(() => {
        axios.get(`${API}/site`).then((r) => setSite(r.data)).catch(() => {});
    }, []);
    const c = site?.content || {};

    return (
        <div className="bg-void text-white min-h-screen" data-testid="app-root">
            <div className="grain-overlay" aria-hidden="true" />
            <Navbar season={c.nav_season} />
            <main>
                <Hero
                    overline={c.hero_overline}
                    tagline={c.hero_tagline}
                    coords={c.hero_coords}
                    coordsNote={c.hero_coords_note}
                />
                <Marquee phrases={c.marquee} />
                <Manifesto chapters={c.chapters} />
                <Collection products={site?.products} blurb={c.collection_blurb} title={c.collection_title} />
                <Marquee phrases={c.marquee} />
                <Lookbook lede={c.lookbook_lede} shots={c.lookbook_shots} />
                <Drop dropTitle={c.drop_title} dropLine={c.drop_line} dropDate={c.drop_date} />
            </main>
            <Footer email={c.footer_email} socials={c.footer_socials} legal={c.footer_legal} tagline={c.footer_tagline} copyright={c.footer_copyright} />
        </div>
    );
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
        };
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Site />} />
                <Route path="/admin" element={<Admin />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
